import { cn } from "@babybjorn/ui";
import type { ChangeEvent, FC } from "react";
import SearchBar from "../../../general/SearchBar";
import SpecialButton from "../../../general/SpecialButton";
import * as s from "./QuickSearchBar.module.scss";

type QuickSearchBarProps = {
	setShowSearch: () => void;
	searchValue: string;
	setSearchValue: (event: ChangeEvent<HTMLInputElement>) => void;
	labels: Record<"searchLabel" | "searchPlaceholder" | "clearLabel", string>;
	clearCallback?: () => void;
	isOpen?: boolean;
};

const QuickSearchBar: FC<QuickSearchBarProps> = ({
	searchValue,
	setShowSearch,
	clearCallback,
	setSearchValue,
	labels,
	isOpen,
}) => {
	const { searchLabel, searchPlaceholder, clearLabel } = labels;

	return (
		<>
			<span className={s.mobile}>
				<span>
					<SpecialButton
						variant="search"
						onClick={setShowSearch}
						label={searchLabel}
					/>
				</span>
			</span>
			<span className={cn(s.desktop)}>
				<span>
					<SearchBar
						onChange={(event) => setSearchValue(event)}
						onClick={setShowSearch}
						inputLabel={searchLabel}
						clearLabel={isOpen ? clearLabel : ""}
						clearCallback={clearCallback}
						searchPlaceholder={isOpen ? searchPlaceholder : searchLabel}
						quickSearchOpen={isOpen}
						quickSearch
						value={searchValue}
					/>
				</span>
			</span>
		</>
	);
};
export default QuickSearchBar;
